import {
    Box,
    Button,
    CloseButton,
    Dialog,
    HStack,
    Link,
    Portal,
    Stack,
    Text,
} from "@chakra-ui/react";
import { ProhibitIcon, XCircleIcon } from "@phosphor-icons/react";

const DisclaimerDialog = ({ isOpen, onClose, onAccept }) => {
    return (
        <Dialog.Root
            lazyMount
            open={isOpen}
            placement="center"
            onOpenChange={(e) => {
                if (!e.open) {
                    onClose();
                }
            }}
        >
            <Portal>
                <Dialog.Backdrop bg="rgba(0, 0, 0, 0.8)" />
                <Dialog.Positioner>
                    <Dialog.Content
                        bg="#0b2a49"
                        color="white"
                        borderRadius="xl"
                        p={0}
                        maxWidth="600px"
                        maxHeight="95vh"
                        mx={{ base: 4, md: "auto" }}
                        position="relative"
                        display="flex"
                        flexDirection="column"
                    >
                        <Box
                            display="flex"
                            flexGrow={1}
                            flexShrink={1}
                            flexDirection="column"
                            mt="60px"
                            minHeight={0} // This is crucial for flex children to shrink
                        >
                            <Stack
                                textAlign="center"
                                p={{ base: 6, md: 8 }}
                                flexGrow={1}
                                overflowY="auto"
                                minHeight={0} // This allows the stack to shrink and scroll
                            >
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    fontWeight={500}
                                    color="white"
                                >
                                    En{" "}
                                    <Text fontWeight={600} as="span" color="#f6cb07">
                                        GUIA EXCELENCIA INMOBILIARIA, S.A. DE C.V.{" "}
                                    </Text>
                                    reiteramos nuestro compromiso con la transparencia y la
                                    seguridad de nuestros clientes.
                                </Text>

                                <Box my={5} w="100%" bg="#FFFFFF1A" p={4} borderRadius="lg">
                                    <Text fontWeight="bold" color="white" mb={2}>
                                        No comercializamos propiedades fuera de lo publicado en
                                        nuestra página oficial{" "}
                                        <Text fontWeight={600} as="span" color="#f6cb07">
                                            www.grupoguia.mx
                                        </Text>
                                    </Text>
                                </Box>

                                <Stack align="start" w="100%">
                                    <HStack align="flex-start" w="100%">
                                        <Box as={XCircleIcon} size={24} color="#f44336" mt={0.5} />
                                        <Text textAlign="left">
                                            No vendemos tiempos compartidos
                                        </Text>
                                    </HStack>

                                    <HStack align="flex-start" w="100%">
                                        <Box as={XCircleIcon} size={24} color="#f44336" mt={0.5} />
                                        <Text textAlign="left">
                                            No operamos rentas vacacionales
                                        </Text>
                                    </HStack>

                                    <HStack align="flex-start" w="100%">
                                        <Box as={ProhibitIcon} size={35} color="#f44336" mt={0.5} />
                                        <Text textAlign="left">
                                            No recibimos dinero bajo ninguna circunstancia por venta
                                            o renta de propiedades.
                                        </Text>
                                    </HStack>
                                </Stack>

                                <Stack
                                    align="center"
                                    textAlign="center"
                                    w="100%"
                                    mt={5}
                                    bg="#FFFFFF1A"
                                    p={3}
                                >
                                    <Text fontWeight="bold">
                                        Todos nuestros promotores están debidamente acreditados.
                                    </Text>
                                    <Text fontStyle="italic">
                                        Para verificar o reportar, contáctanos:
                                    </Text>
                                    <Text color="#f6cb07" fontWeight="bold">
                                        atencionaclientes@grupoguia.mx | 33 1868 1590 (WhatsApp)
                                    </Text>
                                </Stack>

                                <Text textAlign="center" mt={4}>
                                    Consulta el comunicado completo{" "}
                                    <Link
                                        color="#f6cb07"
                                        fontWeight="bold"
                                        textDecoration="underline"
                                        _hover={{ color: "white" }}
                                        onClick={() => {
                                            window.open("/aviso-a-clientes", "_blank");
                                        }}
                                        cursor="pointer"
                                    >
                                        aquí
                                    </Link>
                                </Text>
                            </Stack>
                        </Box>

                        <Dialog.Footer p={{ base: 4, md: 6 }}>
                            <HStack spacing={8} justify="flex-end" w="100%">
                                <Button
                                    onClick={() => {
                                        window.open("/aviso-a-clientes", "_blank");
                                    }}
                                    color="#213a69"
                                    bg="white"
                                    size="lg"
                                    borderRadius="full"
                                    maxW="150px"
                                    px={8}
                                >
                                    Más información
                                </Button>
                                <Button
                                    onClick={onAccept}
                                    color="#213a69"
                                    bg="#f6cb07"
                                    size="lg"
                                    borderRadius="full"
                                    maxW="150px"
                                    px={8}
                                >
                                    Entendido
                                </Button>
                            </HStack>
                        </Dialog.Footer>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton
                                size="md"
                                color="white"
                                borderRadius="md"
                                _hover={{ background: "#f6cb07" }}
                            />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default DisclaimerDialog;
